<ng-template #template>
  <sk-toggle [label]="'label.project.ShowAllProjects' | translate"
             [noSubscriptBox]="true"
             [ngModel]="engine.includeCompletedProjectsInSearch$ | async"
             (ngModelChange)="engine.setIncludeCompletedProjectsInSearch($event)"></sk-toggle>
</ng-template>
